import React from "react";

import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
import { toastMessage } from "utils/toastMessage";
import { deleteSelectedBanner } from "services/banner-management";

const DeleteBanner = ({
  deleteModal,
  selectedBannerDetail,
  setFetchedBannerData,
  closeModel,
}) => {

  const [bannerButtonLoader, setBannerButtonLoader] = useButtonLoader("Yes");

  const deleteBannerHandler = async () => {
    try {
      setBannerButtonLoader(true);
      const {
        data: { code, status, message },
      } = await deleteSelectedBanner(selectedBannerDetail._id);
      if (status || code === 200) {
        // Remove the deleted category from the list
        setFetchedBannerData((prevList) =>
          prevList.filter(
            (bannerProp) => bannerProp._id !== selectedBannerDetail._id
          )
        );
        closeModel();
        toastMessage(message, "success", "DeleteCategory");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setBannerButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={deleteModal}
        handleClose={closeModel}
        content="Are you sure you want to Delete this Banner?"
        title="Delete Banner"
        buttonLoader={bannerButtonLoader}
        action={deleteBannerHandler}
      />
    </>
  );
};

export default DeleteBanner;
